var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 96 96",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "background"), /*#__PURE__*/React.createElement("rect", {
    x: -1,
    y: -1,
    width: 582,
    height: 402,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("g", {
    stroke: "null"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m88.713 88.748h-82.06c-1.8431 0-3.536-0.98167-4.4476-2.5744s-0.91156-3.5561 0.020041-5.1388l41.03-71.802c0.92157-1.5727 2.6044-2.5443 4.4275-2.5443 1.8231 0 3.506 0.97165 4.4276 2.5443l41.03 71.802c0.93159 1.5827 0.93159 3.546 0.020028 5.1388-0.91156 1.5927-2.6145 2.5744-4.4476 2.5744z",
    fill: "#FFC107"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m42.554 73.722c0-0.69118 0.1202-1.3122 0.37063-1.9133 0.24041-0.58098 0.581-1.0919 1.0318-1.5126 0.44075-0.43074 0.98168-0.77132 1.6027-1.0117 0.62107-0.23038 1.3223-0.36062 2.1036-0.36062 0.79134 0 1.4925 0.13023 2.1236 0.36062 0.64109 0.24041 1.182 0.581 1.6228 1.0117 0.45077 0.42071 0.80137 0.93159 1.0318 1.5126 0.25042 0.60102 0.37063 1.2221 0.37063 1.9133 0 0.69118-0.1202 1.3223-0.37063 1.9033-0.24041 0.57097-0.581 1.0718-1.0318 1.5026-0.44075 0.43074-0.98167 0.7613-1.6228 1.0117-0.63108 0.2304-1.3323 0.3506-2.1236 0.3506-0.78134 0-1.4825-0.1202-2.1036-0.36062-0.62105-0.24041-1.162-0.57097-1.6027-1.0017-0.45077-0.43074-0.80137-0.93159-1.0318-1.5026-0.25042-0.581-0.37063-1.2121-0.37063-1.9033m8.9252-10.618h-7.623l-1.0818-30.772h9.7767l-1.0718 30.772z",
    fill: "#5D4037"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.2fd9eaa1ed243fcffba9c0f1e39cc460.svg";
export { ForwardRef as ReactComponent };